export default {
  "nav.spreadsheet": "USFans Spreadsheet",
  "nav.reviews": "Reviews",
  "nav.shipping": "Shipping",
  "nav.guides": "Guides",
  "nav.safety": "Safety",
  "nav.faq": "FAQ",
  "nav.cta": "Explore Spreadsheet",
  "nav.home": "Home",
  "nav.shoppingGuide": "Shopping Guide",

  "hero.eyebrow": "THE USFANS RESOURCE HUB",
  "hero.h1": "USFans Spreadsheet — Find, Compare & Explore USFans Resources",
  "hero.subtitle": "Looking for a clearer way to explore USFans spreadsheets, product information, seller resources, QC guides and shipping information? USFansLink brings useful USFans resources together in one organized, searchable hub.",
  "hero.ctaPrimary": "Explore USFans Spreadsheet",
  "hero.ctaSecondary": "Read the USFans Guide",
  "hero.trust": "Independent resource • Updated regularly • Built for easier research",
  "hero.cardBadge": "USFans Spreadsheet",
  "hero.cardTitle": "Organized resource hub",
  "hero.cardText": "Browse categories, compare guides and jump straight to the products you need.",

  "buttons.usfans": "usfans spreadsheet",
  "buttons.buyNow": "Buy It Now",

  "categories.title": "Browse by Category",
  "categories.subtitle": "Pick a category below and jump straight to the products you need on our main website.",
  "categories.placeholder": "Select a category",
  "categories.go": "Go to category",

  "cat.shoes": "Shoes",
  "cat.hoodies": "Hoodies / Sweaters",
  "cat.tshirts": "T-Shirts",
  "cat.jackets": "Jackets",
  "cat.pants": "Pants / Shorts",
  "cat.headwear": "Headwear",
  "cat.sets": "Sets",
  "cat.underwear": "Underwear / Underpants",
  "cat.jersey": "Jersey",
  "cat.accessories": "Accessories",
  "cat.bags": "Bags",
  "cat.belts": "Belts",
  "cat.perfumes": "Perfumes",
  "cat.other": "Other Stuff",

  "value.title": "Everything You Need to Research USFans in One Place",
  "value.subtitle": "Organized, practical resources that help you evaluate information before making a decision.",
  "value.card1.title": "USFans Spreadsheet",
  "value.card1.text": "Explore organized spreadsheet resources and learn how to evaluate information before making decisions.",
  "value.card2.title": "USFans Reviews",
  "value.card2.text": "Understand the key factors to check when researching USFans and related services.",
  "value.card3.title": "Shipping Information",
  "value.card3.text": "Learn how shipping costs, methods, delivery options and potential fees can differ.",
  "value.card4.title": "QC Resources",
  "value.card4.text": "Understand quality-control photos, product details and common things buyers should verify.",
  "value.card5.title": "Safety Center",
  "value.card5.text": "Learn how to recognize suspicious links, protect accounts and evaluate external websites.",

  "featured.title": "Explore the USFans Spreadsheet",
  "featured.text": "Use our USFans Spreadsheet resource as a starting point for research. Compare information, explore related guides and discover practical resources without jumping between scattered pages.",
  "featured.cta": "View USFans Spreadsheet",

  "review.title": "USFans Review: What Should You Check?",
  "review.text": "Before using any online shopping or sourcing service, it is important to research reputation, available information, shipping options, warehouse processes, payment practices and account security. Our guides explain what to look for so you can make a more informed decision.",
  "review.cta": "Read USFans Review Guide",

  "shipping.title": "USFans Shipping Cost Guide",
  "shipping.text": "Shipping costs can vary depending on destination, package size, weight, shipping method and other factors. Learn how to compare shipping options and understand the information shown before placing an order.",
  "shipping.cta": "Explore Shipping Guide",

  "safety.title": "Is USFans Legit? Learn What to Check",
  "safety.text": "Searching for “USFans legit”? Don't rely on a single review or social post. Learn how to evaluate website URLs, payment pages, account security, seller information, external links and other trust signals.",
  "safety.cta": "Read USFans Safety Guide",

  "article.title": "Latest USFans Guide",
  "article.text": "Our original, in-depth USFans Spreadsheet guide covers what it is, how to use it, what to check before buying, and the key safety points to keep in mind.",
  "article.cta": "Read the full guide",

  "final.title": "Ready to Explore USFans Resources?",
  "final.text": "Start with the USFans Spreadsheet, explore the latest guides and use the information that best matches your research needs.",
  "final.ctaPrimary": "Explore USFans Spreadsheet",
  "final.ctaSecondary": "Visit Main Website",

  "pillars.eyebrow": "USFans Guides",
  "pillars.title": "USFans Pillar Guides",
  "pillars.subtitle": "In-depth original guides covering the USFans Spreadsheet, shipping, safety, QC, coupons and more.",
  "pillars.readMore": "Read more",

  "footer.tagline": "An independent resource hub that brings useful USFans resources together in one organized place.",
  "footer.disclosure": "Independently operated informational resource. Not officially affiliated with USFans.",
  "footer.explore": "Explore",
  "footer.resources": "Resources",
  "footer.navHome": "Home",
  "footer.navGuide": "USFans Spreadsheet Guide",
  "footer.navCategories": "Categories",
  "footer.rights": "All rights reserved."
};